<template>
  <v-container class="about">
    <video :src="videoUrl" controls="controls" height="75%" v-if="video" width="75%"></video>
    <br>
    <a :href="videoUrl" style="margin-left: 10px">download</a>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      video: null
    }
  },
  mounted() {
    this.video = this.$route.query.video
  },
  computed: {
    videoUrl() {
      return `/vfds/ovfd/${this.video}.mp4`
    }
  }
}
</script>